"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsRelayPayloadMaxSize = exports.OrgPageDef_definitionPayloadMaxBody = exports.DataRefRecordsMaxChars = void 0;
exports.DataRefRecordsMaxChars = 1024 * 128;
exports.OrgPageDef_definitionPayloadMaxBody = '128kb';
exports.WsRelayPayloadMaxSize = '1mb';
//# sourceMappingURL=data-size-limits.js.map